import styled from 'styled-components';

export const Container = styled.nav`
  display: none;
  align-items: center;
  gap: 24px;

  > a,
  button {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: 0;
    color: ${({ theme }) => theme.colors.grey.white};
  }
`;

export const ButtonLink = styled.button`
  min-height: 44px;
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 0;

  svg {
    width: 32px;
    height: 32px;
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const Menu = styled.div`
  width: 50%;
  height: 100vh;
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.grey[600]};
  border-radius: 8px 0 0 8px;
  overflow: hidden;
  border-left: 1px solid ${({ theme }) => theme.colors.primary.main};

  div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;

    img {
      width: 100%;
      max-width: 180px;
    }
  }

  button {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: 0;
    margin-left: auto;
    margin-top: 8px;
    padding: 4px;

    svg {
      width: 40px;
      height: 40px;
      transform: rotate(45deg);
      color: ${({ theme }) => theme.colors.grey.white};
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.8;
    }
  }

  a {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 48px;
    border-top: 1px solid ${({ theme }) => theme.colors.primary.main};
    border-bottom: 1px solid ${({ theme }) => theme.colors.primary.main};

    &:hover {
      transition: 0.7s;
      background-color: ${({ theme }) => theme.colors.grey[700]};
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
    border-radius: 0;
    border: 0;
    z-index: 2;
  }
`;
